(function($) {
  /* ==== CLIENT FORM ==== */

  if ($('#client-form').length) {
    /**
     * Define variables
     */
    var clientForm = $('#client-form');
    var submitButton = clientForm.find('#edit-button');
    var deleteButton = clientForm.find('#delete-button');
    var loader = clientForm.find('#client-form-loader');
    var clientId = clientForm.find('#client-id');
    var clientName = clientForm.find('#client-name');
    var clientEmail = clientForm.find('#client-email');
    var clientAddress = clientForm.find('#client-address');
    var message = clientForm.find('#client-form-message');
    var deleteConfirmationText = clientForm.find('#client-form-delete-confirmation-text').text();

    /**
     * Submit Button - Click Handler
     */
    submitButton.on('click', function(e) {
      e.preventDefault();
      editClient();
    });

    /**
     * Client Form - Submit Handler
     */
    clientForm.on('submit', function (e) {
      e.preventDefault();
      editClient();
    });

    /**
     * Edit Client
     */
    function editClient() {
      loader.show();

      message.html('');
      message.removeClass('error');

      $.ajax({
        type: 'POST',
        url: ajax_object.ajaxurl,
        data: {
          action: 'add_or_edit_client',
          id: clientId.val(),
          name: clientName.val(),
          email: clientEmail.val(),
          address: clientAddress.val(),
        },
        success: function(data) {
          if (data.success) {
            if (clientId.val()) {
              // Client updated
              message.html(data.message);
              loader.hide();
            } else {
              // Client created
              window.location.href = data.permalink + '?added=1';
            }
          } else {
            message.html(data.message);
            message.addClass('error');
            loader.hide();
          }
        },
        error: function(response) {
          console.log('An error occurred while trying to edit client.');
          console.log(response);

          loader.hide();
        },
      });
    }

    /**
     * Delete Button - Click Handler
     */
    deleteButton.on('click', function(e) {
      e.preventDefault();
      
      if (confirm(deleteConfirmationText) == true) {
        loader.show();

        message.html('');
        message.removeClass('error');

        $.ajax({
          type: 'POST',
          url: ajax_object.ajaxurl,
          data: {
            action: 'delete_client',
            id: clientId.val(),
          },
          success: function(data) {
            if (data.success) {
              // Client deleted
              window.location.href = data.permalink;
            } else {
              message.html(data.message);
              message.addClass('error');
              loader.hide();
            }
          },
          error: function(response) {
            console.log('An error occurred while trying to delete the client.');
            console.log(response);

            loader.hide();
          },
        });
      }
    });
  }
})(jQuery);
